import React, { useEffect, useState } from "react";
import api from "../services/api";
import ProductCard from "./ProductCard";
import ScrollReveal from "./ScrollReveal";

const ProductsNew = ({ products: initialProducts }) => {
  const [products, setProducts] = useState(initialProducts || []);
  const [loading, setLoading] = useState(!initialProducts);

  useEffect(() => {
    if (initialProducts) {
      setProducts(initialProducts);
      setLoading(false);
      return;
    }

    api
      .get("/products")
      .then((res) => {
        const productArray = res.data.products || res.data.data || res.data;

        if (Array.isArray(productArray)) {
          const sortedProducts = [...productArray].sort(
            (a, b) => new Date(b.created_at) - new Date(a.created_at),
          );
          setProducts(sortedProducts);
        }
      })
      .catch((err) => console.error(err))
      .finally(() => setLoading(false));
  }, [initialProducts]);

  const displayProducts = products.slice(0, 12);

  if (loading) {
    return (
      <div className="py-12 text-center">
        <div className="inline-block w-8 h-8 border-4 border-blue-600 border-t-transparent rounded-full animate-spin"></div>
        <p className="mt-4 text-gray-500 dark:text-slate-400 font-medium">Đang tải sản phẩm mới...</p>
      </div>
    );
  }

  return (
    <div className="grid grid-cols-2 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4 sm:gap-6">
      {displayProducts.map((product, i) => (
        <ScrollReveal
          key={product._id}
          variants="fade-up"
          delay={i * 0.1}
          distance={20}
        >
          <ProductCard product={product} />
        </ScrollReveal>
      ))}
    </div>
  );
};

export default ProductsNew;
